export default {
  "slots": {
    "root": "min-h-[calc(100vh-var(--ui-header-height))] flex flex-col items-center justify-center text-center",
    "statusCode": "text-base font-semibold text-(--ui-primary)",
    "statusMessage": "mt-2 text-4xl sm:text-5xl font-bold text-(--ui-text-highlighted) text-balance",
    "message": "mt-4 text-lg text-(--ui-text-muted) text-balance",
    "links": "mt-8 flex items-center justify-center gap-6"
  }
}